class FreeDeliveryProgress extends HTMLElement {
  constructor() {
    super();
    this.threshold = parseFloat(this.dataset.threshold) || 0;
    this.progressFill = this.querySelector('.product__free-delivery-progress-fill');
    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.updateProgress();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.updateProgress();
      });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async updateProgress() {
    if (this.threshold <= 0) return;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartTotal = cart.total_price;
      const percentage = Math.min((cartTotal / this.threshold) * 100, 100);

      if (this.progressFill) {
        this.progressFill.style.width = `${percentage}%`;
      }

      this.classList.toggle('is-complete', percentage >= 100);
    } catch (error) {
      console.error('[FreeDeliveryProgress] Error fetching cart:', error);
    }
  }
}

customElements.define('free-delivery-progress', FreeDeliveryProgress);
